/**
 * The settings shell's dialogs: the unsaved-changes question (the prototype's "Save changes?") and the
 * item filter ("Enabled items only").
 */

import { useState } from 'react';
import { DialogFrame, registerDialog, type DialogProps } from '../../app/dialogs.js';
import { ui } from '../../app/ui-store.js';
import { Toggle } from '../../ui/form.js';

export interface UnsavedChangesProps {
  onKeep(): void;
  onDiscard(): void;
  onSave(): Promise<void> | void;
  name?: string;
}

export function UnsavedChangesDialog({ close, dialogId, onKeep, onDiscard, onSave, name }: DialogProps & UnsavedChangesProps) {
  const keep = (): void => {
    close();
    onKeep();
  };
  return (
    <DialogFrame title="Save changes?" className="small-dialog" onClose={keep} dialogId={dialogId}>
      <p>
        Your changes to <strong>{name ?? 'this item'}</strong> have not been saved.
      </p>
      <div className="dialog-footer">
        <button type="button" className="secondary-button" onClick={keep}>
          Keep editing
        </button>
        <button
          type="button"
          className="secondary-button"
          onClick={() => {
            close();
            onDiscard();
          }}
        >
          Discard
        </button>
        <button
          type="button"
          className="primary-button"
          onClick={() => {
            close();
            void onSave();
          }}
        >
          Save changes
        </button>
      </div>
    </DialogFrame>
  );
}

export function SettingsFilterDialog({ close, dialogId }: DialogProps) {
  const [enabledOnly, setEnabledOnly] = useState(ui.get().settingsEnabledOnly);
  return (
    <DialogFrame title="Filter items" className="small-dialog" onClose={close} dialogId={dialogId}>
      <form
        id="filter-form"
        onSubmit={(e) => {
          e.preventDefault();
          ui.set({ settingsEnabledOnly: enabledOnly });
          close();
        }}
      >
        <Toggle label="Enabled items only" name="enabled" checked={enabledOnly} onChange={setEnabledOnly} />
        <div className="dialog-footer">
          <button type="submit" className="primary-button">
            Apply
          </button>
        </div>
      </form>
    </DialogFrame>
  );
}

let registered = false;
export function registerSettingsDialogs(): void {
  if (registered) return;
  registered = true;
  registerDialog<UnsavedChangesProps>('unsaved-changes', UnsavedChangesDialog);
  registerDialog('settings-filter', SettingsFilterDialog);
}
